import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useQueryCustomerBrands() {
  const { customerService } = useService();
  const { data, isLoading, isFetching } = useQuery<string[], Error>('customer-brands', () =>
    customerService.getCustomerBrands()
  );

  return { brandOptions: data, isLoading, isFetching } as const;
}
